import { Component, HostBinding, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { Location, NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../shared/animations/page-transitions';
import { UserService } from '../../../shared/services/user.service';
import { UserCardService } from '../../services/user-card.service';
import { UserInfo } from '../../../shared/models/user-info';
import { BackButtonComponent } from '../../../shared/components/back-button/back-button.component';

@Component({
	selector: 'copo-user-card',
	templateUrl: './user-card.component.html',
	styleUrl: './user-card.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [BackButtonComponent, TranslateModule, MatButtonModule, RouterLink, NgIf, RouterOutlet]
})
export class UserCardComponent implements OnDestroy {
	@HostBinding('class.passthrough') readonly passthrough = true;

	firstName: string;
	lastName: string;
	userId?: number;
	userServiceSub?: Subscription;
	firstNameSubscription: Subscription;
	lastNameSubscription: Subscription;

	constructor(
		private readonly location: Location,
		private readonly router: Router,
		private readonly userService: UserService,
		private readonly route: ActivatedRoute,
		private readonly userCardService: UserCardService
	) {
		this.firstNameSubscription = this.userCardService.subscribeToFirstName({
			next: firstName => {
				if (firstName) {
					this.firstName = firstName;
				}
			}
		});
		this.lastNameSubscription = this.userCardService.subscribeToLastName({
			next: lastName => {
				if (lastName) {
					this.lastName = lastName;
				}
			}
		});
		const res = <{ user: UserInfo }> this.route.snapshot.data;
		const userInfo = res['user'];
		this.userId = userInfo.id;
		this.firstName = userInfo.firstName;
		this.lastName = userInfo.lastName;
	}

	getRouteParam() {
		return this.isSelfCard() ? 'self' : this.userId;
	}

	isActivate(suffix: string) {
		return this.router.url.endsWith(suffix);
	}

	isSelfCard() {
		const loginUser = this.userService.loggedUser;
		if (loginUser === undefined) {
			return false;
		}
		return this.router.url.includes('self') || this.userId === loginUser.id;
	}

	getBack() {
		this.location.back();
	}

	ngOnDestroy() {
		this.firstNameSubscription.unsubscribe();
		this.lastNameSubscription.unsubscribe();
	}
}
